<template>
  <div class="pop" v-if="isShow">
    <div class="pop-container">
      <div class="pop-container-head">
        <p>{{ title || '' }}</p>
        <span @click="handleClose"><icon type="iconic_cancel_pop"></icon></span>
      </div>
      <div class="pop-container-content">
        <div class="pop-container-content-txt">
          {{ message || '系统出现错误，请稍后再试！' }}
        </div>
        <div class="pop-container-content-button" @click="handleClick">
          <button>确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: String,
    title: String,
    callback: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      isShow: true,
    };
  },
  methods: {
    handleClose() {
      this.isShow = false;
    },
    handleClick() {
      if (typeof this.callback === 'function') {
        this.callback();
      }
      this.isShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.pop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 99;
  display: flex;
  align-items: center;
  justify-items: center;

  &-container {
    margin: 0 auto;
    background-color: red;
    background: #ffffff;
    z-index: 3;
    width: 436px;
    height: 202px;
    &-head {
      display: flex;
      margin: 10px;
      font-size: 16px;
      color: #222226;
      justify-content: space-between;

      span {
        .icon {
          width: 14px;
          height: 14px;
          font-size: 12px;
          opacity: 0.4;
        }
        cursor: pointer;
      }
    }
    &-content {
      font-weight: 600;
      font-size: 17px;
      &-txt {
        text-align: center;
        padding: 30px;
      }
      &-button {
        margin: 0 auto;
        width: 116px;
        height: 34px;
        line-height: 34px;
        border-radius: 17px;
        background: #417ff9;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        button {
          color: #ffffff;
          display: inline-block;
          line-height: 34px;
          background-color: transparent;
          outline: none;
          border: none;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
